<div class="session-handoff">
  <div class="session-handoff__header">
    <h1>Ready to join the notary session</h1>
    <p class="session-handoff__subtitle">
      Please confirm the participants below who will be joining the notary session from this device.
    </p>
  </div>

  <div class="session-handoff__participants">
    @for (participant of participants(); track participant.packageUserGuid) {
    <app-participant-card
      [participant]="participant"
      [associatedUsers]="associatedUsers()"
      (joinSession)="onJoinSession($event)"
    >
    </app-participant-card>
    }
  </div>

  <div class="session-handoff__footer">
    <app-button [isDisabled]="!hasAssociatedUsers()" (buttonClick)="onContinue()" type="primary">
      {{ continueButtonText() }}
    </app-button>
  </div>
</div>
